import { render } from "./password.vue?vue&type=template&id=490e364f"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import "./password.vue?vue&type=style&index=0&id=490e364f&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__